import { PollGroup } from './poll-group';

export class FilteredPollGroups {
    constructor(
        public totalItems?: number,
        public pollGroups?: PollGroup[],
    ) { }

    clone() {
        return new FilteredPollGroups(
            this.totalItems,
            this.pollGroups,
        );
    }
}
